import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Checkbox } from './va-checkbox';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'va-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <mat-checkbox
      [disabled]="config.disabled"
      [checked]="config.checked"
      [indeterminate]="config.indeterminate"
      (change)="config.onClick($event.checked)"
    />
  `,
  imports: [CommonModule, MatCheckboxModule],
})
export class VaCheckboxComponent {
  @Input() config: Checkbox;
}
